var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 10,
  viewBox: "0 0 26 10",
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11.9226,
  height: 8,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10.929,
  y: 4,
  width: 4.96776,
  height: 4,
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9342 1.89808C10.929 1.9489 10.929 2.00927 10.929 2.13V3.87C10.929 3.99073 10.929 4.0511 10.9342 4.10192C10.9825 4.57358 11.3554 4.94647 11.827 4.99479C11.8779 5 11.9382 5 12.059 5H14.7667C14.8874 5 14.9478 5 14.9986 4.99479C15.4703 4.94647 15.8432 4.57358 15.8915 4.10192C15.8967 4.0511 15.8967 3.99073 15.8967 3.87V2.13C15.8967 2.00927 15.8967 1.9489 15.8915 1.89808C15.8432 1.42642 15.4703 1.05353 14.9986 1.00521C14.9478 1 14.8874 1 14.7667 1H12.059C11.9382 1 11.8779 1 11.827 1.00521C11.3554 1.05353 10.9825 1.42642 10.9342 1.89808ZM12.9225 2C12.3702 2 11.9225 2.44772 11.9225 3C11.9225 3.55228 12.3702 4 12.9225 4H13.9031C14.4554 4 14.9031 3.55228 14.9031 3C14.9031 2.44772 14.4554 2 13.9031 2H12.9225Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.48398 10C3.30706 10 3.97431 9.32843 3.97431 8.5C3.97431 7.67157 3.30706 7 2.48398 7C1.66089 7 0.993652 7.67157 0.993652 8.5C0.993652 9.32843 1.66089 10 2.48398 10ZM2.484 9C2.75836 9 2.98078 8.77614 2.98078 8.5C2.98078 8.22386 2.75836 8 2.484 8C2.20964 8 1.98722 8.22386 1.98722 8.5C1.98722 8.77614 2.20964 9 2.484 9ZM5.46465 9C5.73902 9 5.96143 8.77614 5.96143 8.5C5.96143 8.22386 5.73902 8 5.46465 8C5.19029 8 4.96788 8.22386 4.96788 8.5C4.96788 8.77614 5.19029 9 5.46465 9ZM12.9163 8.5C12.9163 8.77614 12.6939 9 12.4195 9C12.1452 9 11.9227 8.77614 11.9227 8.5C11.9227 8.22386 12.1452 8 12.4195 8C12.6939 8 12.9163 8.22386 12.9163 8.5ZM6.95498 8.5C6.95498 9.32843 6.28774 10 5.46465 10C4.64157 10 3.97433 9.32843 3.97433 8.5C3.97433 7.67157 4.64157 7 5.46465 7C6.28774 7 6.95498 7.67157 6.95498 8.5ZM12.4195 10C13.2426 10 13.9098 9.32843 13.9098 8.5C13.9098 7.67157 13.2426 7 12.4195 7C11.5964 7 10.9292 7.67157 10.9292 8.5C10.9292 9.32843 11.5964 10 12.4195 10Z"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20.0388,
  width: 5.96131,
  height: 8,
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 17.4966,
  y: 4,
  width: 2,
  height: 1,
  transform: "rotate(29.7561 17.4966 4)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.0005,
  y: 7,
  width: 2,
  height: 1,
  transform: "rotate(-30 17.0005 7)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5226 10C23.3456 10 24.0129 9.32843 24.0129 8.5C24.0129 7.67157 23.3456 7 22.5226 7C21.6995 7 21.0322 7.67157 21.0322 8.5C21.0322 9.32843 21.6995 10 22.5226 10ZM22.5226 9C22.7969 9 23.0194 8.77614 23.0194 8.5C23.0194 8.22386 22.7969 8 22.5226 8C22.2482 8 22.0258 8.22386 22.0258 8.5C22.0258 8.77614 22.2482 9 22.5226 9Z"
})));

export default __webpack_public_path__ + "static/media/VehicleCloseToTheFront.fa6cc89f.svg";
export { SvgComponent as ReactComponent };